import { getParameter } from "./getParameter";
export const debugLog = (text, text2) => {
    if (process.env.MODE === "development" && getParameter("nexusdebug") !== "false") {
        const timestamp = Math.round(performance.now()).toString();
        if (text2 !== undefined) {
            console.log("%c[" + timestamp + "] Nexus: %c " + text + " ", "color: #7d44ff", "background-color: #ebd6f2; color: #333333; border-radius: 8px", text2);
        }
        else {
            console.log("%c[" + timestamp + "] Nexus: %c " + text + " ", "color: #7d44ff", "background-color: #ebd6f2; color: #333333; border-radius: 8px");
        }
    }
};
